import axios from '../utils/axios';

const API_URL = '/api';

const getAuthConfig = () => {
  const token = localStorage.getItem('adminToken');
  return {
    headers: { 
      Authorization: `Bearer ${token}`
    }
  };
};

export const blogService = {
  // Get all blogs
  getBlogs: async () => {
    const response = await axios.get(`${API_URL}/blogs`);
    return response.data;
  },

  // Get admin blogs (includes drafts)
  getAdminBlogs: async () => {
    const response = await axios.get(`${API_URL}/blogs/admin`, getAuthConfig());
    return response.data;
  },

  // Get single blog
  getBlog: async (id) => {
    const response = await axios.get(`${API_URL}/blogs/${id}`, getAuthConfig());
    return response.data;
  },

  // Create new blog
  createBlog: async (formData) => {
    const response = await axios.post(
      `${API_URL}/blogs`, 
      formData,
      {
        ...getAuthConfig(),
        headers: {
          ...getAuthConfig().headers,
          'Content-Type': 'multipart/form-data'
        }
      }
    );
    return response.data;
  },

  // Update blog
  updateBlog: async (id, formData) => {
    const response = await axios.patch(
      `${API_URL}/blogs/${id}`,
      formData,
      {
        ...getAuthConfig(),
        headers: {
          ...getAuthConfig().headers,
          'Content-Type': 'multipart/form-data'
        }
      }
    );
    return response.data;
  },

  // Delete blog
  deleteBlog: async (id) => {
    const response = await axios.delete(`${API_URL}/blogs/${id}`, getAuthConfig());
    return response.data;
  }
};
